import React from 'react'

export default function Footer() {
	return (
		<div className="footer">
			<div className="container-main w-container">
				<div className="footer-wrap">
					<div className="social-media-wrapper position-none static _2em-top-margin">
						<a
							href="#"
							target="_blank"
							className="round-social-wrapper dc _1em-right-margin w-inline-block">
							<img
								src="https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61e448384b97dedec918d034_Discord.svg"
								loading="lazy"
								alt="Discord icon blue"
							/>
						</a>
						<a
							href="#"
							target="_blank"
							className="round-social-wrapper tw _1em-right-margin w-inline-block">
							<img
								src="https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61e444dbf012c2f4c7c1c8c3_Twitter.svg"
								loading="lazy"
								alt="Twitter icon blue"
							/>
						</a>
						<a
							href="#"
							target="_blank"
							className="round-social-wrapper w-inline-block">
							<img
								src="https://uploads-ssl.webflow.com/61850b66c37b75624b6fbe19/61e444db8d89ef6eed863ce8_Instagram.svg"
								loading="lazy"
								alt="Instagram icon blue"
							/>
						</a>
					</div>
				</div>
				<div className="bottom-footer">
					<div className="text-block-7">
						2022 MetaMates Ape Lounge. All rights reserved.
					</div>
				</div>
			</div>
		</div>
	)
}
